export const NOT_FOUND_ERROR_CODE = 404;
export const BAD_REQUSET_ERROR_CODE = 400;
